import { useIntl } from "react-intl"
import styled from "styled-components"

interface CenteredErrorMessageProps {
  className?: string

  intlId?: string
  defaultMessage?: string
  message?: string
  marginTop?: string
  noAccess?: boolean
}

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const CenteredErrorMessage: React.CFC<CenteredErrorMessageProps> = ({
  className,

  intlId,
  defaultMessage,
  message,
  noAccess,
}) => {
  const intl = useIntl()
  const _message = noAccess
    ? intl.formatMessage({
        id: "permissions.no-access-to-page",
        defaultMessage: "No access",
      })
    : intlId
      ? intl.formatMessage({
          id: intlId,
          defaultMessage: defaultMessage,
        })
      : message ||
        intl.formatMessage({
          id: "server.general-error-update",
          defaultMessage: "Server error. Please try refreshing the page.",
        })
  return <Layout className={className}>{_message}</Layout>
}
